// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"268":"4ab1248be5a3f758","647":"ad22c6c9396f33c8"}[chunkId] + ".js";
};